import MDTypography from "components/MDTypography";

export default function walletOperationsTableData(wallet) {
  if (!wallet) return { columns: [], rows: [] };
  const rows = [];

  // عمليات الشحن (إيداع)
  (wallet.wallet_topup || []).forEach((op) => {
    rows.push({
      type: "شحن",
      amount: op.amount,
      currency: wallet.currency?.name || "-",
      fromTo: wallet.user?.name || "-",
      date: op.created_at ? op.created_at.split("T")[0] : "-",
      status: op.status === "completed" ? "مكتملة" : op.status,
      description: op.method || "-",
    });
  });

  // عمليات السحب
  (wallet.wallet_withdrawal || []).forEach((op) => {
    rows.push({
      type: "سحب",
      amount: op.amount,
      currency: wallet.currency?.name || "-",
      fromTo: wallet.user?.name || "-",
      date: op.created_at ? op.created_at.split("T")[0] : "-",
      status: op.status === "processed" ? "مكتملة" : op.status,
      description: op.method || "-",
    });
  });

  // التحويلات الصادرة
  (wallet.sent_transfers || []).forEach((op) => {
    rows.push({
      type: "تحويل صادر",
      amount: op.amount,
      currency: wallet.currency?.name || "-",
      fromTo: op.to_wallet?.user?.name || "-",
      date: op.created_at ? op.created_at.split("T")[0] : "-",
      status: op.status === "completed" ? "مكتملة" : op.status,
      description: op.note || op.transactions?.[0]?.description || "-",
    });
  });

  // التحويلات الواردة
  (wallet.received_transfers || []).forEach((op) => {
    rows.push({
      type: "تحويل وارد",
      amount: op.amount,
      currency: wallet.currency?.name || "-",
      fromTo: op.from_wallet?.user?.name || "-",
      date: op.created_at ? op.created_at.split("T")[0] : "-",
      status: op.status === "completed" ? "مكتملة" : op.status,
      description: op.note || op.transactions?.[0]?.description || "-",
    });
  });

  return {
    columns: [
      { Header: "نوع العملية", accessor: "type", align: "center" },
      { Header: "المبلغ", accessor: "amount", align: "center" },
      { Header: "العملة", accessor: "currency", align: "center" },
      { Header: "من/إلى", accessor: "fromTo", align: "center" },
      { Header: "التاريخ", accessor: "date", align: "center" },
      { Header: "الحالة", accessor: "status", align: "center" },
      { Header: "الوصف", accessor: "description", align: "center" },
    ],
    rows,
  };
}
